export default __webpack_public_path__ + "static/report-content-07-20f0b1318c52d85d3f448a56a0a3fccf.png";